import { useContext } from 'react'
import { createCtx } from '../../../../context/_createCtx'
import { UserMenuContextValues } from './_props'

const defaultValues: UserMenuContextValues = {
    isOpen: false,
}

const [ctx, provider] = createCtx(defaultValues)

export const UserMenuContextProvider = provider

export const useUserMenuContext = () => useContext(ctx)
